import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-ui-nav-following", -1),
    _createElementVNode("g", { "fill-rule": "nonzero" }, [
      _createElementVNode("path", { d: "M8.333 7.976v56.049a5 5 0 0 0 10 0V7.976a5 5 0 1 0-10 0zM51.916 28H30a4 4 0 1 1 0-8h22.336l-5.399-6.427a4 4 0 0 1 6.126-5.146l10.5 12.5c.688.82.991 1.834.93 2.823a3.986 3.986 0 0 1-.93 2.823l-10.5 12.5a4 4 0 0 1-6.126-5.146L51.917 28z" })
    ], -1)
  ]))]))
}
export default { render: render }